export default {
    state: {
        users: [],
        user: [],
        user_id: null,
        url: '/api/hms/users/list',
        errors: {},
        form: {
            name: '',
            gender: '',
            position: '',
            employee_id: '',
            company: '',
            project: '',
            address: '',
            phone: '',
            fax: '',
            email: '',
            password: '',
            confirm_password: '',
            note: '',
        },
        meta: {
            current_page: 1,
            per_page: 10,
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'code', label: 'Code', sortable: true, tdClass: ''},
                {key: 'name', label: 'Name', sortable: true, tdClass: ''},
                {key: 'position', label: 'Position', tdClass: ''},
                {key: 'company', label: 'Company', sortable: true, tdClass: 'text-muted'},
                {key: 'project', label: 'Project', sortable: true, tdClass: 'text-muted'},
                {key: 'email', label: 'E-mail', sortable: true, tdClass: 'text-muted'},
                {
                    key: 'created_at',
                    label: 'Created At',
                    sortable: true,
                    thClass: 'text-center',
                    tdClass: 'text-center'
                },
                {key: 'status', label: 'Status', thClass: 'text-center', tdClass: 'text-center'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        other_form: {},

    },

    getters: {
        getUserTableFields: state => state.table.fields,

        getUsersMeta: state => state.meta,

        getUserForm: state => state.form,

        getUserErrors: state => state.errors,

        getUserOtherForm: state => state.other_form,
    },

    mutations: {
        setUsers: (state, payload) => {
            state.facilities = payload;
        },

        setUser: (state, payload) => {
            state.user_id = payload.user_id;
            state.user = payload;
        },

        setUsersMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setUserErrors: (state, payload) => {
            state.errors = payload;
        },

        resetUsersMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },
        setUserForm: state => {
            state.form = {
                name: '',
                gender: '',
                position: '',
                employee_id: '',
                company: '',
                project: '',
                address: '',
                phone: '',
                fax: '',
                email: '',
                password: '',
                confirm_password: '',
                note: '',
            };

            state.errors = {};
        },

        setUserOtherForm: state => {
            state.other_form = {
                status: state.user.data.attributes.status,
                body: '',
            };

            state.errors = {};
        },
    },

    actions: {
        fetchUsers: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setUsers', response.data);

                        commit('setUsersMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setUserErrors', error.response.data.errors);

                        reject();
                    });
            });
        },

        fetchUser: ({state, commit}, user_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + user_id)
                    .then(response => {
                        commit('setUser', response.data);

                        commit('setUserOtherForm', response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        fetchEditUser: ({state, commit}, user_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + user_id + '/edit')
                    .then(response => {
                        state.user_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitUser: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setUserErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateUser: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.user_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setUserErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        submitUserStatus: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.user_id + '/status', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setUserErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        submitUserComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url + '/' + state.user_id + '/comments', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setUserErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateUserComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.user_id + '/comments/' + payload.id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setUserErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteUser: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.user_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },

        deleteUserComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + state.user_id + '/comments/' + payload.comment_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
